import React from 'react'
import { Card, CardImg, CardHeader, CardBody } from 'reactstrap'
import technicalIssues from '../../assets/img/techincal_issues/technical_issues.svg'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

class TechnicalIssues extends React.Component {
    render() {
        const { t } = this.props
        return (
            <Card className="technical-issues">
                <CardHeader className="p-0">
                    <CardImg src={technicalIssues} alt="" />
                </CardHeader>
                <CardBody className="p-0">
                    <h1 className="title xxl-font-size m-0">{t('page-technical-title')}</h1>
                    <h3 className="subtitle xl-font-size m-0">Technical work is being carried out on the site</h3>
                </CardBody>
            </Card>
        )
    }
}

TechnicalIssues.propTypes = {
    t: PropTypes.func,
}

export default withTranslation()(TechnicalIssues)



// WEBPACK FOOTER //
// ./src/views/Pages/TechnicalIssues.jsx